import React from 'react';
import styles from './Message.module.css';
import type { ThreadMessage } from '../types';
import { formatTime } from '../lib/time';

interface MessageProps {
  message: ThreadMessage;
  isBot?: boolean;
  children?: React.ReactNode;
}

function renderText(text: string): React.ReactNode {
  const parts = text.split(/(@prd-bot|\bapproved\b|\bapprove\b)/gi);
  return parts.map((part, i) => {
    if (part.toLowerCase() === '@prd-bot') {
      return (
        <span key={i} className={styles.mention}>
          @prd-bot
        </span>
      );
    }
    if (part.toLowerCase() === 'approved' || part.toLowerCase() === 'approve') {
      return (
        <span key={i} className={styles.mention}>
          {part}
        </span>
      );
    }
    return part;
  });
}

export default function Message({ message, isBot, children }: MessageProps) {
  return (
    <div className={styles.message} data-testid="thread-message">
      <div className={styles.avatar}>
        {message.avatarUrl ? <img src={message.avatarUrl} alt={message.userName} /> : null}
      </div>
      <div className={styles.body}>
        <div className={styles.header}>
          <span className={styles.userName}>{message.userName}</span>
          {isBot ? <span className={styles.botLabel}>APP</span> : null}
          <span className={styles.timestamp}>{formatTime(message.timestamp)}</span>
        </div>
        <div className={styles.text}>{renderText(message.text)}</div>
        {children ? <div className={styles.botCard}>{children}</div> : null}
      </div>
    </div>
  );
}
